@file:OptIn(InternalResourceApi::class)

package soccerconvertscript.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/soccerconvertscript.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_757_491_177)
internal val Res.string.add_to_calendar_cd: StringResource by lazy {
      StringResource("string:add_to_calendar_cd", "add_to_calendar_cd", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 50),
      ))
    }

@delegate:ResourceContentHash(420_701_077)
internal val Res.string.contact: StringResource by lazy {
      StringResource("string:contact", "contact", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 184, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 160, 27),
      ))
    }

@delegate:ResourceContentHash(1_956_360_475)
internal val Res.string.contact_prompt: StringResource by lazy {
      StringResource("string:contact_prompt", "contact_prompt", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 69, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 61, 98),
      ))
    }

@delegate:ResourceContentHash(-1_917_356_295)
internal val Res.string.download_calendar: StringResource by lazy {
      StringResource("string:download_calendar", "download_calendar", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 269, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 241, 49),
      ))
    }

@delegate:ResourceContentHash(-1_917_358_087)
internal val Res.string.download_calendar_cd: StringResource by lazy {
      StringResource("string:download_calendar_cd", "download_calendar_cd", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 212, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 188, 52),
      ))
    }

@delegate:ResourceContentHash(-743_380_810)
internal val Res.string.error_calendar_export: StringResource by lazy {
      StringResource("string:error_calendar_export", "error_calendar_export", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 323, 153),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 291, 121),
      ))
    }

@delegate:ResourceContentHash(-1_835_649_460)
internal val Res.string.error_empty_csv: StringResource by lazy {
      StringResource("string:error_empty_csv", "error_empty_csv", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 477, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 413, 107),
      ))
    }

@delegate:ResourceContentHash(-1_544_376_484)
internal val Res.string.error_empty_events: StringResource by lazy {
      StringResource("string:error_empty_events", "error_empty_events", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 585, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 521, 102),
      ))
    }

@delegate:ResourceContentHash(611_835_041)
internal val Res.string.error_parse: StringResource by lazy {
      StringResource("string:error_parse", "error_parse", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 704, 143),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 624, 111),
      ))
    }

@delegate:ResourceContentHash(-1_535_730_426)
internal val Res.string.error_url_paste: StringResource by lazy {
      StringResource("string:error_url_paste", "error_url_paste", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 848, 191),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 736, 183),
      ))
    }

@delegate:ResourceContentHash(1_040_638_417)
internal val Res.string.game_schedule: StringResource by lazy {
      StringResource("string:game_schedule", "game_schedule", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1040, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 920, 41),
      ))
    }

@delegate:ResourceContentHash(-546_515_752)
internal val Res.string.gender_boys: StringResource by lazy {
      StringResource("string:gender_boys", "gender_boys", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1094, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 962, 27),
      ))
    }

@delegate:ResourceContentHash(1_896_009_116)
internal val Res.string.gender_girls: StringResource by lazy {
      StringResource("string:gender_girls", "gender_girls", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1122, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 990, 28),
      ))
    }

@delegate:ResourceContentHash(-1_226_665_725)
internal val Res.string.group_grade_gender: StringResource by lazy {
      StringResource("string:group_grade_gender", "group_grade_gender", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1151, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1019, 46),
      ))
    }

@delegate:ResourceContentHash(1_815_430_702)
internal val Res.string.instruction_open_cd: StringResource by lazy {
      StringResource("string:instruction_open_cd", "instruction_open_cd", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1198, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1066, 35),
      ))
    }

@delegate:ResourceContentHash(1_347_048_751)
internal val Res.string.instruction_open_subtitle: StringResource by lazy {
      StringResource("string:instruction_open_subtitle", "instruction_open_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1234, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1102, 85),
      ))
    }

@delegate:ResourceContentHash(943_709_556)
internal val Res.string.instruction_paste_cd: StringResource by lazy {
      StringResource("string:instruction_paste_cd", "instruction_paste_cd", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1332, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1188, 36),
      ))
    }

@delegate:ResourceContentHash(599_100_289)
internal val Res.string.instruction_paste_subtitle: StringResource by lazy {
      StringResource("string:instruction_paste_subtitle", "instruction_paste_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1369, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1225, 70),
      ))
    }

@delegate:ResourceContentHash(228_272_917)
internal val Res.string.instruction_select_all_cd: StringResource by lazy {
      StringResource("string:instruction_select_all_cd", "instruction_select_all_cd", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1440, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1296, 49),
      ))
    }

@delegate:ResourceContentHash(-732_893_206)
internal val Res.string.instruction_select_all_subtitle: StringResource by lazy {
      StringResource("string:instruction_select_all_subtitle", "instruction_select_all_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1498, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1346, 63),
      ))
    }

@delegate:ResourceContentHash(1_528_562_464)
internal val Res.string.label_club: StringResource by lazy {
      StringResource("string:label_club", "label_club", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1570, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1410, 26),
      ))
    }

@delegate:ResourceContentHash(-719_298_120)
internal val Res.string.label_coach: StringResource by lazy {
      StringResource("string:label_coach", "label_coach", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1597, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1437, 27),
      ))
    }

@delegate:ResourceContentHash(1_635_851_764)
internal val Res.string.label_games: StringResource by lazy {
      StringResource("string:label_games", "label_games", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1633, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1465, 27),
      ))
    }

@delegate:ResourceContentHash(678_999_116)
internal val Res.string.label_group: StringResource by lazy {
      StringResource("string:label_group", "label_group", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1665, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1493, 27),
      ))
    }

@delegate:ResourceContentHash(-2_040_272_941)
internal val Res.string.label_season: StringResource by lazy {
      StringResource("string:label_season", "label_season", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1693, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1521, 32),
      ))
    }

@delegate:ResourceContentHash(-1_499_123_154)
internal val Res.string.language_default: StringResource by lazy {
      StringResource("string:language_default", "language_default", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1730, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1554, 36),
      ))
    }

@delegate:ResourceContentHash(-2_005_328_783)
internal val Res.string.language_english: StringResource by lazy {
      StringResource("string:language_english", "language_english", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1591, 36),
      ))
    }

@delegate:ResourceContentHash(516_919_908)
internal val Res.string.language_settings: StringResource by lazy {
      StringResource("string:language_settings", "language_settings", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1771, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1628, 37),
      ))
    }

@delegate:ResourceContentHash(530_396_056)
internal val Res.string.language_spanish: StringResource by lazy {
      StringResource("string:language_spanish", "language_spanish", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1666, 36),
      ))
    }

@delegate:ResourceContentHash(-1_083_604_489)
internal val Res.string.next_step_bulk: StringResource by lazy {
      StringResource("string:next_step_bulk", "next_step_bulk", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1805, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1703, 78),
      ))
    }

@delegate:ResourceContentHash(2_035_640_857)
internal val Res.string.next_step_import: StringResource by lazy {
      StringResource("string:next_step_import", "next_step_import", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1900, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1782, 120),
      ))
    }

@delegate:ResourceContentHash(1_137_057_424)
internal val Res.string.next_step_individual: StringResource by lazy {
      StringResource("string:next_step_individual", "next_step_individual", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2021, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1903, 116),
      ))
    }

@delegate:ResourceContentHash(2_059_939_417)
internal val Res.string.opponent_tbd: StringResource by lazy {
      StringResource("string:opponent_tbd", "opponent_tbd", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2142, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2020, 24),
      ))
    }

@delegate:ResourceContentHash(1_682_485_302)
internal val Res.string.page_source_label: StringResource by lazy {
      StringResource("string:page_source_label", "page_source_label", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2179, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2045, 41),
      ))
    }

@delegate:ResourceContentHash(1_554_100_409)
internal val Res.string.page_source_placeholder: StringResource by lazy {
      StringResource("string:page_source_placeholder", "page_source_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2233, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2087, 71),
      ))
    }

@delegate:ResourceContentHash(-1_169_823_553)
internal val Res.string.submit: StringResource by lazy {
      StringResource("string:submit", "submit", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2321, 22),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2159, 22),
      ))
    }

@delegate:ResourceContentHash(-2_040_033_580)
internal val Res.string.success_title: StringResource by lazy {
      StringResource("string:success_title", "success_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2344, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2182, 33),
      ))
    }

@delegate:ResourceContentHash(1_492_543_776)
internal val Res.string.vs_opponent: StringResource by lazy {
      StringResource("string:vs_opponent", "vs_opponent", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2378, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2216, 31),
      ))
    }

@delegate:ResourceContentHash(810_563_916)
internal val Res.string.welcome_title: StringResource by lazy {
      StringResource("string:welcome_title", "welcome_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2410, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2248, 77),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("add_to_calendar_cd", Res.string.add_to_calendar_cd)
  map.put("contact", Res.string.contact)
  map.put("contact_prompt", Res.string.contact_prompt)
  map.put("download_calendar", Res.string.download_calendar)
  map.put("download_calendar_cd", Res.string.download_calendar_cd)
  map.put("error_calendar_export", Res.string.error_calendar_export)
  map.put("error_empty_csv", Res.string.error_empty_csv)
  map.put("error_empty_events", Res.string.error_empty_events)
  map.put("error_parse", Res.string.error_parse)
  map.put("error_url_paste", Res.string.error_url_paste)
  map.put("game_schedule", Res.string.game_schedule)
  map.put("gender_boys", Res.string.gender_boys)
  map.put("gender_girls", Res.string.gender_girls)
  map.put("group_grade_gender", Res.string.group_grade_gender)
  map.put("instruction_open_cd", Res.string.instruction_open_cd)
  map.put("instruction_open_subtitle", Res.string.instruction_open_subtitle)
  map.put("instruction_paste_cd", Res.string.instruction_paste_cd)
  map.put("instruction_paste_subtitle", Res.string.instruction_paste_subtitle)
  map.put("instruction_select_all_cd", Res.string.instruction_select_all_cd)
  map.put("instruction_select_all_subtitle", Res.string.instruction_select_all_subtitle)
  map.put("label_club", Res.string.label_club)
  map.put("label_coach", Res.string.label_coach)
  map.put("label_games", Res.string.label_games)
  map.put("label_group", Res.string.label_group)
  map.put("label_season", Res.string.label_season)
  map.put("language_default", Res.string.language_default)
  map.put("language_english", Res.string.language_english)
  map.put("language_settings", Res.string.language_settings)
  map.put("language_spanish", Res.string.language_spanish)
  map.put("next_step_bulk", Res.string.next_step_bulk)
  map.put("next_step_import", Res.string.next_step_import)
  map.put("next_step_individual", Res.string.next_step_individual)
  map.put("opponent_tbd", Res.string.opponent_tbd)
  map.put("page_source_label", Res.string.page_source_label)
  map.put("page_source_placeholder", Res.string.page_source_placeholder)
  map.put("submit", Res.string.submit)
  map.put("success_title", Res.string.success_title)
  map.put("vs_opponent", Res.string.vs_opponent)
  map.put("welcome_title", Res.string.welcome_title)
}
